import {
    Bug,
    BookOpen,
    Check,
    CircleX,
    Code2,
    Database,
    Download,
    FileCode2,
    GitBranch,
    GitCommitHorizontal,
    GitCompareArrows,
    GitFork,
    GitMerge,
    GitPullRequestCreate,
    Goal,
    Hammer,
    Lightbulb,
    ListChecks,
    MessageSquare,
    Package,
    PackageCheck,
    Play,
    RefreshCw,
    Rocket,
    Save,
    Search,
    ShieldCheck,
    Sparkles,
    SquareTerminal,
    Star,
    TestTube2,
    Timer,
    Trash2,
    Upload,
    Workflow,
    Wrench,
} from "lucide-react"
import type { LucideIcon } from "lucide-react"
import type { SavedActionIcon } from "./actionTypes"

export const SAVED_ACTION_ICON_PRESETS: ReadonlyArray<{ id: SavedActionIcon; label: string; icon: LucideIcon }> = [
    { id: "sparkles", label: "Sparkles", icon: Sparkles },
    { id: "play", label: "Play", icon: Play },
    { id: "check", label: "Check", icon: Check },
    { id: "commit", label: "Commit", icon: GitCommitHorizontal },
    { id: "push", label: "Git push", icon: GitCompareArrows },
    { id: "pull-request", label: "PR", icon: GitPullRequestCreate },
    { id: "git-branch", label: "Branch", icon: GitBranch },
    { id: "terminal", label: "Terminal", icon: SquareTerminal },
    { id: "wrench", label: "Wrench", icon: Wrench },
    { id: "search", label: "Search", icon: Search },
    { id: "test", label: "Test", icon: TestTube2 },
    { id: "rocket", label: "Rocket", icon: Rocket },
    { id: "package", label: "Package", icon: Package },
    { id: "wrap-up", label: "Close out", icon: PackageCheck },
    { id: "bug", label: "Bug", icon: Bug },
    { id: "refresh", label: "Refresh", icon: RefreshCw },
    { id: "close", label: "Close", icon: CircleX },
    { id: "trash", label: "Trash", icon: Trash2 },
    { id: "code", label: "Code", icon: Code2 },
    { id: "file", label: "File", icon: FileCode2 },
    { id: "save", label: "Save", icon: Save },
    { id: "upload", label: "Upload", icon: Upload },
    { id: "download", label: "Download", icon: Download },
    { id: "merge", label: "Merge", icon: GitMerge },
    { id: "fork", label: "Fork", icon: GitFork },
    { id: "checklist", label: "Checklist", icon: ListChecks },
    { id: "shield", label: "Shield", icon: ShieldCheck },
    { id: "hammer", label: "Build", icon: Hammer },
    { id: "database", label: "Database", icon: Database },
    { id: "workflow", label: "Workflow", icon: Workflow },
    { id: "book", label: "Docs", icon: BookOpen },
    { id: "idea", label: "Idea", icon: Lightbulb },
    { id: "timer", label: "Timer", icon: Timer },
    { id: "goal", label: "Goal", icon: Goal },
    { id: "message", label: "Message", icon: MessageSquare },
    { id: "star", label: "Star", icon: Star },
]

const ICONS_BY_ID = new Map(SAVED_ACTION_ICON_PRESETS.map((preset) => [preset.id, preset.icon]))

export function savedActionIcon(icon: SavedActionIcon): LucideIcon {
    return ICONS_BY_ID.get(icon) ?? Sparkles
}
